import React from 'react';
import moment from 'moment';
import { Radio, Collapse } from '@blueprintjs/core';
import { Link } from 'react-router';

class QuaTrinhXuLy extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state ={
      isOpen: true
    }
  }

  handleCollapse() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    let QuaTrinhXuLy = '';
    if(this.props.parents.state.dataLichSuQuaTrinhXuLy) {
      QuaTrinhXuLy = this.props.parents.state.dataLichSuQuaTrinhXuLy.map((item,i) => {
        return (
          <div className="history-items" key={i}>
            <div className="radio-column">
              <Radio defaultChecked={ true }/>
            </div>
            <div className="group-val">
              <span className="txt-bold txt-upper">{item.ten ? item.ten : null}</span>
              <span className="val-content">{item.ngayXuLy ? moment(item.ngayXuLy).format('DD/MM/YYYY - HH:mm') : null}</span>
            </div>
            <div className="group-val">
              <span className="txt-bold">Người xử lý:</span>
              <span className="val-content">{item.nguoiXuLyText ? item.nguoiXuLyText : null}</span>
            </div>
            <div className="group-val">
              <span className="txt-bold">Nội dung:</span>
              <span className="val-content">{item.noiDung ? item.noiDung : null}</span>
            </div>
          </div>
        );
      });
    } else {
      QuaTrinhXuLy = (<div></div>);
    }

    return (
      <section className="wrap-history gqd-history">
        <div className="wrap-big-line pl20">
          <h2 className={this.state.isOpen ? " collapse-title mb25 pt10 collapse-open" : "collapse-title mb25 pt10 collapse-close"}><Link className="title-14" onClick={this.handleCollapse.bind(this)}>Quá trình xử lý</Link></h2>
        </div>
        <Collapse className="wrap-collapses" isOpen={this.state.isOpen}>
          {QuaTrinhXuLy}
        </Collapse>
      </section>
    );
  }
}

export default QuaTrinhXuLy;


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/QuaTrinhXuLy.jsx